import Image from "next/image";
import { Typography } from "@/components/ui";
import { usePhoto, UsePhotoProps } from "./use-photo";

export type PhotoProps = UsePhotoProps;

export const Photo = (props: PhotoProps) => {
  const { className, styles, data, type, handleClick } = usePhoto(props);
  const { image, alt, title, description, position } = data;

  return (
    <div className={styles.base({ className })}>
      <div className={styles.figure()} onClick={handleClick}>
        <div className={styles.overlay()}>
          {!!alt && type === "photo" && (
            <div className={styles.caption()}>
              <Typography className={styles.label()}>{alt}</Typography>
            </div>
          )}
          <Image
            className={styles.image()}
            src={image}
            alt={alt}
            fill
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
          />
        </div>
      </div>
      {!!title && type === "floor" && (
        <div className={styles.caption()}>
          <Typography
            fontFamily="chillen"
            fontSize="heading-xs"
            spacing="wide"
            uppercase
          >
            {title}
          </Typography>
          <Typography spacing="wide">{description}</Typography>
          {position && <Typography spacing="wide">{position}</Typography>}
        </div>
      )}
    </div>
  );
};
